import loadable from '@loadable/component';

export const LivestreamBanners = loadable(() => import('./index'));
